<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/JobAgentAuditStock'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group ">
                  <label class="label">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reJrLastActivityDateStart"
                      name="reJrLastActivityDateStart"
                      ref="reJrLastActivityDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

               <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reJrLastActivityDateEnd"
                      name="reJrLastActivityDateEnd"
                      ref="reJrLastActivityDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group"> 
                   <div class="form-group">
                  <label>Week:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reWeek'"
                    :name="'reWeek'"
                    :select2-options="reWeekOptions"
                    v-model="reWeek"
                  ></select2>
                </div>
                </div>
              </div>

               <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAaAgentCode'"
                    :name="'reAaAgentCode'"
                    :select2-options="reAaAgentCodeOptions"
                    multiple
                    v-model="reAaAgentCode"
                  ></select2> -->
                  <treeselect
                    v-model="reAaAgentCode"
                    :multiple="true"
                    :options="reAaAgentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

               <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJrProductType'"
                    :name="'reJrProductType'"
                    :select2-options="reJrProductTypeOptions"
                    multiple
                    v-model="reJrProductType"
                    ref="reJrProductTypeSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reJrProductType"
                    :multiple="true"
                    :options="reJrProductTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>


              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reJrProductBrand'"
                    :name="'reJrProductBrand'"
                    :select2-options="reJrProductBrandOptions"
                    multiple
                    v-model="reJrProductBrand"
                    ref="reJrProductBrandSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reJrProductBrand"
                    :multiple="true"
                    :options="reJrProductBrandOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

               <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reApMaterialCode'"
                    :name="'reApMaterialCode'"
                    :select2-options="reApMaterialCodeOptions"
                    multiple
                    v-model="reApMaterialCode"
                    ref="reApMaterialCodeSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reApMaterialCode"
                    :multiple="true"
                    :options="reApMaterialCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                  
                </div>
              </div> 

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAaStatus'"
                    :name="'reAaStatus'"
                    :select2-options="reAaStatusOptions"
                    v-model="reAaStatus"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>เลขที่ใบงาน:</label>
                  <input v-model="jobNumber"
                                   type="text"
                                   class="form-control"
                                   placeholder="ค้นหาจาก เลขที่ใบงาน" />
                </div>
              </div> 

               
            </div>

             

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportJobStock"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <div class="row">
            <div class="col-lg-12 table-responsive" >
              <!-- Top scrollbar -->
              <div ref="topScrollWrapper" style="overflow-x:auto; overflow-y:hidden; height:20px;">
                <div ref="topScrollContent" style="height:1px;"></div>
              </div>
               <table  class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="jobStockTable"
                style="width:100%">
                <thead >
                   <tr>
                    <th class="all text-right" colspan="14">
                      ข้อมูล ณ วันที่ {{ reJrDateReq }}
                    </th>
                  </tr>
                  <tr style="background:#f2f2f2;">
                    <th class="text-center">ปี</th>
                    <th class="text-center">เดือน</th>
                    <th class="text-center">วัน</th>
                    <th class="text-center">Week</th>
                    <th class="text-center">เลขที่ใบงาน</th>
                    <th class="text-center">วันที่เคลื่อนไหวล่าสุด</th>
                    <th class="text-center">รหัสตัวแทนจำหน่าย</th>
                    <th class="text-center">ชื่อตัวแทนจำหน่าย</th>
                    <th class="text-center">รหัสสินค้า</th>
                    <th class="text-center">ชื่อสินค้า</th>
                    <th class="text-center" style="color: #63A361 !important;background-color: #E2EFDA !important; ">ถังเต็ม</th>
                    <th class="text-center" style="color: #BF124D !important;background-color: #F9DFDF !important; ">ถังเปล่า</th>
                    <th class="text-center" style="background-color: #D9D9D9 !important; ">ระหว่างใช้งาน</th>
                    <th class="text-center">หมายเหตุ</th>
                  </tr>
                </thead>
                <tfoot>
                <tr style="background-color: #ddd !important;">
                  <th colspan="10" style="text-align:right">Grand Total </th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tfoot>
 
              </table> 
            </div>
          </div>
          <!--end: Table -->


        </div>
      </div>
    </div>
  </div>

 
</template>

  <style>
  .group-header {
    background-color: #ddd !important;
    font-weight: bold;
  }
  .group-header td.td-header {
    background-color: #f4f4f4 !important;
    font-weight: bold;
  }

  .group-footer {
    background-color: #f4f4f4 !important;
    font-weight: bold;
  } 

  .group-footer-sub td.td-footer{
    background-color: #f1efef !important;
    font-weight: bold;
    padding-left: 0 !important;
    font-size: 15px !important;
  }  
  .group-footer td.td-footer{
    background-color: #ddd !important;
    font-weight: bold;
    padding-left: 0 !important;
  } 
  .jas-bg-red{
     background-color: #FBEFEF !important;
  }
  .jas-bg-red-strong{
     background-color: #F9DFDF !important;
  }
  .jas-bg-green{
     background-color: #E2EFDA !important;
  }
   .jas-bg-gray{
     background-color: #D9D9D9 !important;
  }

</style>
<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

// CSS
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.css";
import { getStyle } from "plupload";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4"); 
require("datatables.net-rowgroup-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");
 
 

let ActionsretrieveJob = Vue.extend({
  template: `
    <a href="#" @click.prevent="openJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="รายละเอียดเอกสารใบงานต้นทาง">
      <i class="la la-external-link"></i>
    </a>
  `,
  methods: {
    openJob: function() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/Jobs/GetJobId", {
          JobNumber: this.data.retrieveJobNumber,
        })
        .then(function(response) {
          if (response.status == 200) {
            window.open("/Jobs/Edit/" + response.data, "_blank");
          } else {
            // always executed
            KTApp.unblockPage();
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
          }
        })
        .catch(function(error) {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
});

let ActionreturnJob = Vue.extend({
  template: `
    <a href="#" @click.prevent="openJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="รายละเอียดเอกสารใบงานต้นทาง">
      <i class="la la-external-link"></i>
    </a>
  `,
  methods: {
    openJob: function() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/Jobs/GetJobId", {
          JobNumber: this.data.returnJobNumber,
        })
        .then(function(response) {
          if (response.status == 200) {
            window.open("/Jobs/Edit/" + response.data, "_blank");
          } else {
            // always executed
            KTApp.unblockPage();
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
          }
        })
        .catch(function(error) {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
});
let ActionsrefJob = Vue.extend({
  template: `
    <a href="#" @click.prevent="openJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="รายละเอียดเอกสารใบงานต้นทาง">
      <i class="la la-external-link"></i>
    </a>
  `,
  methods: {
    openJob: function() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/Jobs/GetJobId", {
          JobNumber: this.data.refJobNumber,
        })
        .then(function(response) {
          if (response.status == 200) {
            window.open("/Jobs/Edit/" + response.data, "_blank");
          } else {
            // always executed
            KTApp.unblockPage();
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
          }
        })
        .catch(function(error) {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
});
export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      
 grandTotal : 0,

      companies : [],
      jobNumber : null,
      columns: null,
      reJrDateReq : null,
      LoadFrist: true,
      reJrIsInitial: true, 
      reJrLastActivityDateStart: null,
      reJrLastActivityDateEnd: null,
      reWeek: null,
      reAaAgentCode: [],
      reAaStatus: null,
      reJrProductBrand: [],
      reApMaterialCode: [],   
      reJrProductType: [],  
      TotalAmount: 10,
      isShowFooter: false,

      reAaAgentCodeOptions: [], 
      reAaStatusOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reJrProductBrandOptions: [], 
      reJrProductTypeOptions: [], 
      reApMaterialCodeOptions: [],   
      reWeekOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        data: [
          { id: "1", text: "1" },
          { id: "2", text: "2" },
          { id: "3", text: "3" },
          { id: "4", text: "4" },
          { id: "5", text: "5" },
        ],
      }, 
    };
  },
  methods: {
    formReset: function(e) {
      let self = this;
      self.reAaAgentCode = [];
      self.reAaStatus = null;
      self.reWeek = null;
      self.jobNumber = null;
      self.reJrLastActivityDateStart = null;
      self.reJrLastActivityDateEnd = null;
      self.reJrLastActivityWeek = null;
      self.reJrProductBrand = []; 
      self.reJrProductType = []; 
      self.reApMaterialCode = []; 

       $("#reWeek")
        .val("")
        .trigger("change");

       $("#reAaStatus")
        .val("")
        .trigger("change");

       $("#reAaAgentCode")
        .val("")
        .trigger("change");

      $("#reJrLastActivityDateStart")
        .val("")
        .trigger("change");

      $("#reJrLastActivityDateEnd")
        .val("")
        .trigger("change");

      $("#reJrLastActivityWeek")
        .val("")
        .trigger("change"); 

      $("#reJrProductBrand")
        .val("")
        .trigger("change");
 
      $("#reJrProductType")
        .val("")
        .trigger("change"); 

      $("#reApMaterialCode")
        .val("")
        .trigger("change");
  
    },
    formResetValue: function (e) {
      let self = this;
      self.reJrLastActivityDateStart = null;
      self.reJrLastActivityDateEnd = null;
      self.reJrProductBrand = [];
       
      self.reJrProductType = []; 
      self.reApMaterialCode = []; 

      $("#reJrLastActivityDateStart")
        .val("")
        .trigger("change");

      $("#reJrLastActivityDateEnd")
        .val("")
        .trigger("change");

      $("#reJrProductBrand")
        .val("")
        .trigger("change");
 
      $("#reJrProductType")
        .val("")
        .trigger("change");
 
      $("#reApMaterialCode")
        .val("")
        .trigger("change");
 

      //this.formSubmit(e, "ล้างค่าทั้งหมด");
    },
    exportJobStock: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportAuditStock",
        responseType: "arraybuffer",
        data: {
            IsInitial : false ,
            ProductType : self.reJrProductType,
            BrandCode: self.reJrProductBrand,
            MaterialCode : self.reApMaterialCode,
            JobNumber  : self.jobNumber,
            BarcodeStatus : self.reAaStatus, 
            AgentCodes: self.reAaAgentCode, 
            WeekNo : self.reWeek ,
            StartDate:
              self.reJrLastActivityDateStart != null
                ? self.reJrLastActivityDateStart.format("DD/MM/YYYY")
                : null,
            EndDate:
              self.reJrLastActivityDateEnd != null
                ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY")
                : null,
        },
      })
       .then(function (response) {
          KTApp.unblockPage();
          if (response.status === 204 || !response.data || response.data.byteLength === 0) {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
            return;
          }
          var blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download =
             moment().format("YYYY-MM-DD") +"_รายงานตรวจสอบSTOCKตัวแทนจำหน่าย"+
            ".xlsx";
          link.click();
        })
        .catch(function () {
          KTApp.unblockPage();
        })
        /*
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
          */
        .then(function() {
          KTApp.unblockPage();
        });
    }, 
    formSubmit: function(e, innerText = null) {
      let self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#jobStockTable").DataTable();
      table.draw();
    },
    // formSubmit: async function (e, innerText = null) {
    //   let self = this;

    //   if (innerText == "ล้างค่าทั้งหมด") {
    //     self.reJrIsInitial = true;
    //   }

    //   if (
    //     !$(this.$refs.form)
    //       .validate()
    //       .form()
    //   ) {
    //     return false;
    //   }

    //   let status = null;
    //   // if(self.reJrReturnStatus !=null){
    //   //   status = $("#reJrReturnStatus").text();
    //   //   console
    //   // }

    //   // e.preventDefault();
    //   // var table = $("#jobRetrieveTable").DataTable();
    //   // table.draw();

    //   e.preventDefault();
    //   // var table = $("#jobRetrieveTable").DataTable();
    //   // var tableSubAgent = $("#jobRetrieveSubAgentTable").DataTable();

    //   // if (self.reViewPermissionCode == "SUB_AGENT_REPORT")
    //   // {
    //   //   await self.GenCollums(tableSubAgent, "submit");
    //   // }
    //   // else
    //   // {
    //   //   await self.GenCollums(table, "submit");
    //   // }
    // }, 
    LoadreAaAgentCodeOptions: function(e) {
      var self = this;
      axios
        // .post("/Api/Agents/Options", {
        //   page: 1,
        //   province_id: [],
        //   department: [],
        //   AgentCodes: [],
        // })
        .post(
          "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
          {
            province_id: [],
            department: [],
            AgentCodes: [],
            page: 1,
            IsShowInAgentScoreReport: true,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAaAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreJrProductBrandOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reJrProductBrandOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },  
    LoadreJrProductTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reJrProductTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    }, 
    LoadreApMaterialCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reApMaterialCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    // sum ต่อบริษัท
    getCompanySum(company)  {
      return company.items.reduce(
        (sum, item) => {
          sum.full += item.full
          sum.empty += item.empty
          return sum
        },
        { full: 0, empty: 0 }
      )
    },
    
    
  },
  async mounted() {
    let self = this;

    function formatNumber(val) {
      return Number(val).toLocaleString("en-US");
    }

    function formatOrDash(val) {
      let num = Number(val);
      if (!num) return "-";
      return formatNumber(num);
    }

    function renderEmpty(val) {
      let num = Number(val);

      if (!num) return "-";

      let formatted = formatNumber(num);

      if (num >= 100) {
        //#63A361#BF124D
        return '<span class="font-weight-bold" style="color:#BF124D !important;">' + formatted + '</span>';
      }

      return formatted;
    }
    //console.log($.fn.dataTable.RowGroup);

    self.LoadreJrProductBrandOptions(); 
    self.LoadreJrProductTypeOptions(); 
    self.LoadreApMaterialCodeOptions();
    self.LoadreAaAgentCodeOptions();
 
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reJrDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reJrLastActivityDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reJrLastActivityDateStart = moment().set("date",1);
    $(self.$refs.reJrLastActivityDateStart)
      .datepicker(
        "update",
        !!self.reJrLastActivityDateStart
          ? self.reJrLastActivityDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reJrLastActivityDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reJrLastActivityDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });


    //self.reJrLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reJrLastActivityDateEnd)
      .datepicker(
        "update",
        !!self.reJrLastActivityDateEnd
          ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reJrLastActivityDateEnd =
          e.dates.length != 0 ? moment(e.date) : null;
      });

      var table = $("#jobStockTable");
    //begin first table
      table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: false,
        scrollX: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/SearchAuditStock",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {

            let jsonSearch = {  
              IsInitial : false ,
              ProductType : self.reJrProductType,
              BrandCode: self.reJrProductBrand,
              MaterialCode : self.reApMaterialCode,
              JobNumber  : self.jobNumber,
              BarcodeStatus : self.reAaStatus, 
              AgentCodes: self.reAaAgentCode, 
              WeekNo : self.reWeek ,
              StartDate:
                self.reJrLastActivityDateStart != null
                  ? self.reJrLastActivityDateStart.format("DD/MM/YYYY")
                  : null,
              EndDate:
                self.reJrLastActivityDateEnd != null
                  ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY")
                  : null,
               
            };

           // alert(JSON.stringify($.extend(d, jsonSearch)));
           // console.log(jsonSearch);
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 50,

        language: {
          lengthMenu: "Display _MENU_",
        },
        
        // Order settings
        // ใช้ลำดับจาก backend (Agent ASC -> Job ที่มีกิจกรรมล่าสุดมาก่อน -> Date DESC ภายใน job)
        // จึงไม่ส่ง initial order และปิด header sort เพื่อกัน user ทำลายโครงสร้าง rowGroup
        order: [],
        columns: [
          { data: "year", className: "text-center" ,orderable: false},
          { data: "monthName", className: "text-left" ,orderable: false},
          { data: "day", className: "text-center" ,orderable: false},
          { data: "weekNo", className: "text-center" ,orderable: false},
          { data: "jobNumber", className: "text-center" ,orderable: false},
          { data: "updatedDate", className: "text-center" ,orderable: false},
          { data: "agentCode", className: "text-center" ,orderable: false},
          { data: "agentName", className: "text-left" ,orderable: false},
          { data: "materialCode", className: "text-center" ,orderable: false},
          { data: "materialDesc", className: "text-left" ,orderable: false},
          {
            data: "full",
            className: "text-center jas-bg-green",
            orderable: false,
            render: function (data, type, row) {
              if (type !== "display") return data;
              return formatOrDash(data);
            }
          },
          {
            data: "empty",
            orderable: false,
            className: "text-center jas-bg-red",
            render: function (data, type, row) {
              if (type !== "display") return data;
              return renderEmpty(data);
            },
            createdCell: function (td, cellData, rowData, row, col) {
              let value = Number(cellData);
              if (value >= 100) {
                $(td).removeClass('jas-bg-red').addClass('jas-bg-red-strong');
              }
            }
          },
          {
            data: "inUse",
            className: "text-center jas-bg-gray",
            orderable: false,
            render: function (data, type, row) {
              if (type !== "display") return data;
              return formatOrDash(data);
            }
          },
          { data: "remark", className: "text-left",orderable: false }
        ],
       rowGroup: {
          // ใช้ composite key (agent + job) เพื่อให้ agent เดียวกันคนละ job แยกเป็นคนละ group
          dataSrc: function (row) {
            return (row.agentName || '') + '|' + (row.jobNumber || '');
          },
          startRender: function (rows, group, level) {
            let agentName = rows.data()[0].agentName;
            return $('<tr class="group-header"/>')
              .append('<td colspan="14" class="td-header">' + agentName + '</td>');
          },
          endRender: function (rows, group, level) {
            let totalFull = rows
              .data()
              .pluck("full")
              .reduce((a, b) => a + Number(b), 0);

            let totalEmpty = rows
              .data()
              .pluck("empty")
              .reduce((a, b) => a + Number(b), 0);

            let totalInUse = rows
              .data()
              .pluck("inUse")
              .reduce((a, b) => a + Number(b), 0);

            let emptyBgClass = totalEmpty >= 100 ? 'jas-bg-red-strong' : 'jas-bg-red';
            return $('<tr class="group-footer-sub"/>')
              .append('<td class="td-footer text-center" colspan="10"> Total ' + rows.data()[0].agentName + '</td>')
              .append('<td class="td-footer text-center text-success" style="color: rgb(99, 163, 97) !important;">' + formatOrDash(totalFull) + '</td>')
              .append('<td class="td-footer text-center ' + emptyBgClass + '">' + renderEmpty(totalEmpty) + '</td>')
              .append('<td class="td-footer text-center">' + formatOrDash(totalInUse) + '</td>')
              .append('<td class="td-footer"></td>');
          }
        },
        footerCallback: function (row, data, start, end, display) {

            let api = this.api();
            let json = api.ajax.json();

            if (!json || !json.groupSummary) return;

            let summary = json.groupSummary;
            // Full (column index 10 after inserting updatedDate at index 5)
            $(api.column(10).footer())
                .html(formatOrDash(summary.totalFull));

            // Empty
            let emptyFooter = $(api.column(11).footer());
            emptyFooter
                .removeClass('jas-bg-red jas-bg-red-strong')
                .addClass(Number(summary.totalEmpty) >= 100 ? 'jas-bg-red-strong' : 'jas-bg-red')
                .html(renderEmpty(summary.totalEmpty));

            // InUse
            $(api.column(12).footer())
                .html(formatOrDash(summary.totalInUse));
        },
        drawCallback: function(settings) {
          self.reAaIsInitial = false;
          //self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a"); 
        },
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    // $(this.$refs.form).validate().settings.ignore = ":hidden";

    // Sync top scrollbar with DataTables scrollBody
    self.$nextTick(function () {
      var scrollBody = $('#jobStockTable').closest('.dataTables_scrollBody');
      var topWrapper = self.$refs.topScrollWrapper;
      var topContent = self.$refs.topScrollContent;
      if (!scrollBody.length || !topWrapper || !topContent) return;

      function syncTopScrollWidth() {
        var bodyTable = scrollBody.find('table');
        var headTable = scrollBody.prev('.dataTables_scrollHead').find('table');
        var w = 0;
        if (bodyTable.length) w = Math.max(w, bodyTable[0].scrollWidth);
        if (headTable.length) w = Math.max(w, headTable[0].scrollWidth);
        topContent.style.width = w + 'px';
      }
      syncTopScrollWidth();

      var syncing = false;
      $(topWrapper).on('scroll', function () {
        if (syncing) return;
        syncing = true;
        scrollBody[0].scrollLeft = topWrapper.scrollLeft;
        syncing = false;
      });
      scrollBody.on('scroll', function () {
        if (syncing) return;
        syncing = true;
        topWrapper.scrollLeft = scrollBody[0].scrollLeft;
        syncing = false;
      });

      $('#jobStockTable').on('draw.dt', function () {
        self.$nextTick(function () { syncTopScrollWidth(); });
      });
    });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/JobAgentAuditStock.vue